import(/* webpackMode: "eager" */ "/vercel/path0/src/app/blog/page.tsx");
